import { findNikkeInCatalog } from '../../nikke-catalog/domain/nikkeCatalog.js';
import { ElementIcon } from '../../nikke-catalog/shared/ElementIcon.jsx';
import { NikkePortraitImage } from '../../nikke-catalog/shared/NikkePortraitImage.jsx';
import { NikkeIcon } from '../../nikke-icons/shared/NikkeIcon.jsx';
import { useNikkeCatalog } from '../../nikke-catalog/hooks/useNikkeCatalog.js';
import { tetrisDeckDisplayCodes } from '../domain/raidTetrisIdentity.js';

function burstRoman(item) {
  const value = String(item?.burst || item?.burstCode || '').trim();
  if (value === '1' || value === 'Step1') return 'I';
  if (value === '2' || value === 'Step2') return 'II';
  if (value === '3' || value === 'Step3') return 'III';
  if (value === 'A' || value === 'AllStep') return 'A';
  return '-';
}

// imageLoading: the 계획표 matrix passes 'eager'. Its cells sit in a scroll container, where Safari's lazy
// loading waits for an image to intersect the viewport rather than come near it.
export function RaidTetrisMiniDeck({ deck = [], compact = false, imageLoading = 'lazy' }) {
  const { catalog } = useNikkeCatalog();
  const codes = tetrisDeckDisplayCodes(deck, catalog);

  return (
    <div className={`raid-tetris-mini-deck ${compact ? 'compact' : ''}`} aria-label="테트리스 덱 5명">
      {Array.from({ length: 5 }, (_, index) => {
        const code = codes[index] || '';
        const item = code ? findNikkeInCatalog(catalog, code) : null;
        const burst = burstRoman(item);
        return (
          <span className="raid-tetris-mini-nikke raid-practice-nikke-art" key={`${code || 'empty'}-${index}`} title={item?.name || code || '빈 슬롯'}>
            <NikkePortraitImage
              src={item?.imageUrl}
              alt=""
              loading={imageLoading}
              fallbackText={item?.name?.slice(0, 1) || '?'}
              fallbackClassName="raid-tetris-mini-fallback"
            />
            {item ? (
              <NikkeIcon
                type="burst"
                iconKey={item.burstCode || item.burst}
                aliases={[item.burst, burst]}
                label={`버스트 ${burst}`}
                imageUrl={item.burstImageUrl}
                fallbackText={burst}
                className="raid-practice-nikke-burst"
                forceText
                scalableGlyph
              />
            ) : null}
            {item ? <ElementIcon loading={imageLoading} element={item.element} imageUrl={item.elementImageUrl} className="raid-practice-nikke-element" /> : null}
          </span>
        );
      })}
    </div>
  );
}
